module.exports = __webpack_public_path__ + "img/warn-status.9ab4393f.png";